import { apiReducer } from "../../../utils/reduxUtil";
import { MODULE_NAME } from "./constants";
const initialState = {
};

function reducer(state = initialState, action) {
  state = apiReducer(state, action, MODULE_NAME);
 return state;
}

export default reducer;
